import { DirectionFlag } from './FileViewer.types';
import { TextItem } from 'pdfjs-dist/types/src/display/api';

export const calculateScale = (scale: number, dir: DirectionFlag, scales: number[]) => {
  const lastIndex = scales.length - 1;
  const index = scales.indexOf(scale) + dir;
  const nextIndex = index < 0 ? 0 : lastIndex < index ? lastIndex : index;
  return scales[nextIndex];
};

export const generatePages = (pages: number) => Array.from(new Array(pages), (_, i) => i + 1);

export const handleFnOnAllPagesRendered = (
  renderedPages: number[],
  page: number,
  pagesCount: number,
  fn: () => void
) => {
  let rendered = [...renderedPages, page];
  if (new Set(rendered).size === pagesCount) {
    rendered = [];
    fn();
  }
  return rendered;
};

export const PDF_LINE_BREAK_SPACE = ' ';

// Mark.js can't find text in following markup: <span>This is</span><br><span>test</span>
// so there is a need to add space between 'is' and 'test'
// space is added before line break: <span>This is </span><br><span>test</span>
export const customTextRenderer = ({ str, hasEOL }: TextItem) => {
  const space = hasEOL ? PDF_LINE_BREAK_SPACE : '';
  return str + space;
};
